exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.grid-container[data-v-83154508] {\n  display: grid;\n  grid-template-columns: -webkit-max-content auto;\n  grid-template-columns: max-content auto;\n  -webkit-column-gap: 8px;\n     -moz-column-gap: 8px;\n          column-gap: 8px;\n  row-gap: 4px;\n}\n#document_number[data-v-83154508] {\n  word-wrap: break-word;\n}\n", ""]);

// exports
